var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUiIconPhone = function SvgUiIconPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 20h14v2H5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.22 12.833s-3.673-.628-5.595-3.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.633 11.612 1.518.249a3.286 3.286 0 0 1 2.702 3.827l-.175.97a1.85 1.85 0 0 1-1.597 1.507 8.883 8.883 0 0 1-2.695-.084l-1.2-.222a12.03 12.03 0 0 1-4.662-1.944l-1.107-.768a14.594 14.594 0 0 1-3.88-3.98l-.835-1.27a6.479 6.479 0 0 1-.957-2.39 2.14 2.14 0 0 1 .808-2.086l.707-.539a3.38 3.38 0 0 1 5.009 1.058l.562 1.021"
  })))));
};
export default SvgUiIconPhone;